import React from 'react';
import { Box } from '@mui/material';

export interface Props {
  message?: string;
}
const PageLoadError = ({ message }: Props) => {
  return <Box>{message || 'Page Load Error'}</Box>;
};

export default PageLoadError;
